import styled from "styled-components";
export const ContentFilterButton = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 6em;
  height: 4em;
  margin: 0.5em 0px 0px 0px;
  align-items: center;
  display: flex;
  justify-content: center;
  .filter-list-icon {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
  &:hover {
    cursor: pointer;
    border-top: 1px solid
      ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const ContentCardAndFilters = styled.div`
  display: grid;
  background-color: ${({ theme }) => theme.background.light};

  .MuiTabs-scroller.MuiTabs-fixed {
    margin-left: 1.5rem;
  }

  .MuiPaper-root,
  th {
    background-color: ${({ theme }) => theme.background.light};
  }
`;
